import { useUploadRestrictions } from "./upload-restrictions.api";

/**
 * UploadRestrictionsWarmup fires the restrictions fetch as soon as the
 * authenticated app mounts, so the query is already cached by the time any
 * upload surface (knowledge sources, tenant logo, chat attachments) needs it.
 */
export function UploadRestrictionsWarmup() {
  useUploadRestrictions();
  return null;
}
